export const baseURL = 'https://admin.mycityreport.jp'
export const baseGeocoderURL = 'https://dev.geocoder.mycityreport.jp/geocoderService/service'
